import {
    ROOM,
    ROOM_SUCCESS,
    ROOM_ERROR,
    ADD_ROOM,
    ADD_ROOM_SUCCESS,
    ADD_ROOM_ERROR,
    UPDATE_ROOM,
    UPDATE_ROOM_SUCCESS,
    UPDATE_ROOM_ERROR,
    DELETE_ROOM,
    DELETE_ROOM_ERROR,
    DELETE_ROOM_SUCCESS,
    ROOM_ITEM,
    ROOM_ITEM_ERROR,
    ROOM_ITEM_SUCCESS
} from "../constants/roomConstant";

const initialState = {
    loading: false,
    success: false,
    error: '',
    type: '',
    loadingTitle: '',
    loadingMessage: ''
};

function roomReducer(state = initialState, action) {
    switch (action.type) {
        case ROOM:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'ROOM',
                'loadingMessage': 'THE ROOMS ARE BEING LOADED',
                'type': action.type
            });
        case ROOM_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case ROOM_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'roomData': action.data,
                'type': action.type
            });
        case ADD_ROOM:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'ROOM',
                'loadingMessage': 'THE ROOM IS BEING ADDED',
                'type': action.type
            });
        case ADD_ROOM_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case ADD_ROOM_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'roomData': [...state.roomData, action.data],
                'type': action.type
            });
        case UPDATE_ROOM:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'ROOM',
                'loadingMessage': 'THE ROOM IS BEING UPDATED',
                'type': action.type
            });
        case UPDATE_ROOM_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case UPDATE_ROOM_SUCCESS:
            const oldRoomData = state.roomData ? state.roomData : []
            let newRoomData
            if (typeof (oldRoomData) === 'object' && oldRoomData.lenght > 0) {
                newRoomData = oldRoomData.map(room => { if (room._id === action.data._id) { return action.data } else { return room } })
            }

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'roomData': newRoomData,
                'type': action.type
            });
        case DELETE_ROOM:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'ROOM',
                'loadingMessage': 'THE ROOM IS BEING DELETED',
                'type': action.type
            });
        case DELETE_ROOM_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case DELETE_ROOM_SUCCESS:

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'roomData': state.roomData.filter(room => room._id !== action.data),
                'type': action.type

            });
        case ROOM_ITEM:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'ROOMS',
                'loadingMessage': 'THE ROOMS ARE BEING LOADED',
                'type': action.type
            });
        case ROOM_ITEM_ERROR:
                return Object.assign({}, state, {
                    'loading': false,
                    'success': false,
                    'error': action,
                    'type': action.type
                });
        case ROOM_ITEM_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'roomItemData': action.data,
                'type': action.type
            });
        default:
            return state;
    }
}

export default roomReducer;

